module.exports = __webpack_public_path__ + "static/interview_reviewer2@2x-f5ce70700f6512ca9bef675d8b9ce87e.png";